import React from 'react';

import { cn } from 'shadcn/lib/utils';

import {
    getCompanySourceBadgeLabel,
    getCompanySourceColors,
} from '../AllocationBreakdown/companySourceAllocationConfig';

/**
 * @param {Object} props
 * @param {string} [props.className]
 * @param {number} props.grandTotal
 * @param {Array<{ companySource: { id: number, code: string, displayName: string }, numCases: number }>} props.bySource
 * @param {boolean} [props.isFbmMode]
 */
function ReceiveFooterSummary({ bySource, className, grandTotal, isFbmMode = false }) {
    return (
        <div
            className={cn(
                'flex flex-1 items-center justify-between gap-4 rounded-lg border bg-muted/30 px-4 py-3',
                className,
            )}
        >
            <p className="text-sm font-medium text-foreground">Grand Total Cases: {grandTotal}</p>
            {!isFbmMode ? (
                <div className="flex flex-wrap items-center justify-end gap-2">
                    {bySource.map(({ companySource, numCases }) => {
                        const badgeLabel = getCompanySourceBadgeLabel(companySource.code);
                        const label = badgeLabel ?? companySource.displayName;
                        const { badgeColor } = getCompanySourceColors(companySource.code);

                        return (
                            <span
                                key={companySource.id}
                                className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium"
                                style={{ borderColor: badgeColor, color: badgeColor }}
                            >
                                {label}: {numCases}
                            </span>
                        );
                    })}
                </div>
            ) : null}
        </div>
    );
}

export { ReceiveFooterSummary };
